import { httpDelete_New, httpGet_New, httpGetFile, httpPatch_New, httpPost_New } from './api.service';
import { PaginatedResult } from '../types/PaginatedResult';
import { PaginatedRequest } from '../requestModels/paginatedRequest';
import { ApkInfo } from '../types/ApkInfo';

/**
 * Retrieve single paginated list of all Android APK versions of mobile app
 */
export const getApkInfos = async (model: PaginatedRequest): Promise<PaginatedResult<ApkInfo>> => await httpGet_New(`api/mobile/apk`, model);

/**
 * Download APK file by fileName
 */
export const downloadApkFile = async (fileName: string): Promise<void> => {
  return await httpGetFile(`api/mobile/apk/${fileName}`);
};

/**
 * Upload an APK file
 */
export const uploadApkFile = async (args: { file: File; version: string; isTestBuild: boolean; isCurrentMarketplaceBuild: boolean }) => {
  const formData = new FormData();
  formData.append('Version', args.version);
  formData.append('IsTestBuild', args.isTestBuild.toString());
  formData.append('IsCurrentMarketplaceBuild', args.isCurrentMarketplaceBuild.toString());
  formData.append('File', args.file);

  return await httpPost_New('api/mobile/apk', formData, true);
};

/**
 * Patch an APK file details
 */
export const patchApkInfo = async (args: { fileName: string; version: string; isTestBuild: boolean; isCurrentMarketplaceBuild: boolean }) => {
  const formData = new FormData();
  formData.append('Version', args.version);
  formData.append('IsTestBuild', args.isTestBuild.toString());
  formData.append('IsCurrentMarketplaceBuild', args.isCurrentMarketplaceBuild.toString());

  return await httpPatch_New(`api/mobile/apk/${args.fileName}`, formData, true);
};

/**
 * Delete an APK file
 */
export const deleteApk = async (fileName: string) => {
  return await httpDelete_New(`api/mobile/apk/${fileName}`);
};
